<template>
  <svg fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" stroke="currentColor"><path d="m16 5-7 7 7 7"></path></svg>
</template>